import React from 'react'
import {useController} from 'react-hook-form'
import Input from 'Src/components/Input'
import {INPUT_NAMES, usePageContext} from 'Src/components/pages/SoftPull/PageContext'
import {trans} from 'Src/utilities/Helpers'

const State = () => {
  const inputName = INPUT_NAMES.STATE
  const {control} = usePageContext()
  const {
    field,
    fieldState: {error},
  } = useController({
    control,
    name: inputName,
    rules: {maxLength: 2},
  })

  return (
    <div className="md:tw-w-2/12" aria-live="assertive" aria-atomic="false">
      <label htmlFor={inputName} className="input-label tw-mb-2">
        {trans('State')}
      </label>
      <Input
        type="text"
        id={inputName}
        className="input-field tw-w-full tw-text-brand-body_text--muted disabled:tw-cursor-not-allowed"
        error={error?.message}
        autoComplete="state"
        maxLength={2}
        disabled
        readOnly
        {...field}
      />
    </div>
  )
}

export default State
